export const Countries = [
  {
    "name": "Afghanistan",
    "code": "AF",
    "capital": "Kabul",
    "region": "Asia",
    "population": 38928346,
    "currency": "AFN"
  },
  {
    "name": "Albania",
    "code": "AL",
    "capital": "Tirana",
    "region": "Europe",
    "population": 2877797,
    "currency": "ALL"
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "capital": "Algiers",
    "region": "Africa",
    "population": 43851044,
    "currency": "DZD"
  },
  {
    "name": "Argentina",
    "code": "AR",
    "capital": "Buenos Aires",
    "region": "Americas",
    "population": 45195774,
    "currency": "ARS"
  },
  {
    "name": "Australia",
    "code": "AU",
    "capital": "Canberra",
    "region": "Oceania",
    "population": 25499884,
    "currency": "AUD"
  },
  {
    "name": "Austria",
    "code": "AT",
    "capital": "Vienna",
    "region": "Europe",
    "population": 9006398,
    "currency": "EUR"
  },
  {
    "name": "Belgium",
    "code": "BE",
    "capital": "Brussels",
    "region": "Europe",
    "population": 11589623,
    "currency": "EUR"
  },
  {
    "name": "Brazil",
    "code": "BR",
    "capital": "Brasília",
    "region": "Americas",
    "population": 212559417,
    "currency": "BRL"
  },
  {
    "name": "Canada",
    "code": "CA",
    "capital": "Ottawa",
    "region": "Americas",
    "population": 37742154,
    "currency": "CAD"
  },
  {
    "name": "Chile",
    "code": "CL",
    "capital": "Santiago",
    "region": "Americas",
    "population": 19116201,
    "currency": "CLP"
  },
  {
    "name": "China",
    "code": "CN",
    "capital": "Beijing",
    "region": "Asia",
    "population": 1439323776,
    "currency": "CNY"
  },
  {
    "name": "Colombia",
    "code": "CO",
    "capital": "Bogotá",
    "region": "Americas",
    "population": 50882891,
    "currency": "COP"
  },
  {
    "name": "Czech Republic",
    "code": "CZ",
    "capital": "Prague",
    "region": "Europe",
    "population": 10708981,
    "currency": "CZK"
  },
  {
    "name": "Denmark",
    "code": "DK",
    "capital": "Copenhagen",
    "region": "Europe",
    "population": 5792202,
    "currency": "DKK"
  },
  {
    "name": "Egypt",
    "code": "EG",
    "capital": "Cairo",
    "region": "Africa",
    "population": 102334404,
    "currency": "EGP"
  },
  {
    "name": "Finland",
    "code": "FI",
    "capital": "Helsinki",
    "region": "Europe",
    "population": 5540720,
    "currency": "EUR"
  },
  {
    "name": "France",
    "code": "FR",
    "capital": "Paris",
    "region": "Europe",
    "population": 65273511,
    "currency": "EUR"
  },
  {
    "name": "Germany",
    "code": "DE",
    "capital": "Berlin",
    "region": "Europe",
    "population": 83783942,
    "currency": "EUR"
  },
  {
    "name": "Greece",
    "code": "GR",
    "capital": "Athens",
    "region": "Europe",
    "population": 10423054,
    "currency": "EUR"
  },
  {
    "name": "India",
    "code": "IN",
    "capital": "New Delhi",
    "region": "Asia",
    "population": 1380004385,
    "currency": "INR"
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "capital": "Jakarta",
    "region": "Asia",
    "population": 273523615,
    "currency": "IDR"
  },
  {
    "name": "Ireland",
    "code": "IE",
    "capital": "Dublin",
    "region": "Europe",
    "population": 4937786,
    "currency": "EUR"
  },
  {
    "name": "Israel",
    "code": "IL",
    "capital": "Jerusalem",
    "region": "Asia",
    "population": 8655535,
    "currency": "ILS"
  },
  {
    "name": "Italy",
    "code": "IT",
    "capital": "Rome",
    "region": "Europe",
    "population": 60461826,
    "currency": "EUR"
  },
  {
    "name": "Japan",
    "code": "JP",
    "capital": "Tokyo",
    "region": "Asia",
    "population": 126476461,
    "currency": "JPY"
  },
  {
    "name": "Kenya",
    "code": "KE",
    "capital": "Nairobi",
    "region": "Africa",
    "population": 53771296,
    "currency": "KES"
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "capital": "Kuala Lumpur",
    "region": "Asia",
    "population": 32365999,
    "currency": "MYR"
  },
  {
    "name": "Mexico",
    "code": "MX",
    "capital": "Mexico City",
    "region": "Americas",
    "population": 128932753,
    "currency": "MXN"
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "capital": "Amsterdam",
    "region": "Europe",
    "population": 17134872,
    "currency": "EUR"
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "capital": "Wellington",
    "region": "Oceania",
    "population": 4822233,
    "currency": "NZD"
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "capital": "Abuja",
    "region": "Africa",
    "population": 206139589,
    "currency": "NGN"
  },
  {
    "name": "Norway",
    "code": "NO",
    "capital": "Oslo",
    "region": "Europe",
    "population": 5421241,
    "currency": "NOK"
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "capital": "Islamabad",
    "region": "Asia",
    "population": 220892340,
    "currency": "PKR"
  },
  {
    "name": "Philippines",
    "code": "PH",
    "capital": "Manila",
    "region": "Asia",
    "population": 109581078,
    "currency": "PHP"
  },
  {
    "name": "Poland",
    "code": "PL",
    "capital": "Warsaw",
    "region": "Europe",
    "population": 37846611,
    "currency": "PLN"
  },
  {
    "name": "Portugal",
    "code": "PT",
    "capital": "Lisbon",
    "region": "Europe",
    "population": 10196709,
    "currency": "EUR"
  },
  {
    "name": "Russia",
    "code": "RU",
    "capital": "Moscow",
    "region": "Europe",
    "population": 145934462,
    "currency": "RUB"
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "capital": "Riyadh",
    "region": "Asia",
    "population": 34813871,
    "currency": "SAR"
  },
  {
    "name": "Singapore",
    "code": "SG",
    "capital": "Singapore",
    "region": "Asia",
    "population": 5850342,
    "currency": "SGD"
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "capital": "Pretoria",
    "region": "Africa",
    "population": 59308690,
    "currency": "ZAR"
  },
  {
    "name": "South Korea",
    "code": "KR",
    "capital": "Seoul",
    "region": "Asia",
    "population": 51269185,
    "currency": "KRW"
  },
  {
    "name": "Spain",
    "code": "ES",
    "capital": "Madrid",
    "region": "Europe",
    "population": 46754778,
    "currency": "EUR"
  },
  {
    "name": "Sweden",
    "code": "SE",
    "capital": "Stockholm",
    "region": "Europe",
    "population": 10099265,
    "currency": "SEK"
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "capital": "Bern",
    "region": "Europe",
    "population": 8654622,
    "currency": "CHF"
  },
  {
    "name": "Thailand",
    "code": "TH",
    "capital": "Bangkok",
    "region": "Asia",
    "population": 69799978,
    "currency": "THB"
  },
  {
    "name": "Turkey",
    "code": "TR",
    "capital": "Ankara",
    "region": "Asia",
    "population": 84339067,
    "currency": "TRY"
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "capital": "Kyiv",
    "region": "Europe",
    "population": 43733762,
    "currency": "UAH"
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "capital": "Abu Dhabi",
    "region": "Asia",
    "population": 9890402,
    "currency": "AED"
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "capital": "London",
    "region": "Europe",
    "population": 67886011,
    "currency": "GBP"
  },
  {
    "name": "United States",
    "code": "US",
    "capital": "Washington, D.C.",
    "region": "Americas",
    "population": 331002651,
    "currency": "USD"
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "capital": "Hanoi",
    "region": "Asia",
    "population": 97338579,
    "currency": "VND"
  }
]